import React from 'react';

import { sortBy } from 'lodash';
import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxOpioidMgmt } from '../../../../libs/apps/epxopioidmgmt';

const EpxOpioidMgmtGraphs: React.FC<GraphInstanceProps> = (
  props
): JSX.Element => {
  const graph: GraphBlueprint<IEpxOpioidMgmt> = {
    name: 'OpioidMgmt Graph',
    config: {
      chart: {
        type: null
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: [
        {
          title: {
            text: 'MME/d'
          },
          min: 0
        },
        {
          title: {
            text: 'Pain Rating'
          },
          min: 0,
          max: 9,
          opposite: true
        }
      ],
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const intakeSeries: GraphSeries = {
        type: 'spline',
        name: 'Daily Intake (MMEd)'
      };
      const thresholdSeries: GraphSeries = {
        type: 'line',
        name: 'Threshold (MMEd)'
      };
      const painSeries: GraphSeries = {
        type: 'spline',
        name: 'Pain Rating (0-9)',
        yAxis: 1
      };
      const data: GraphPoint[][] = [[], [], []];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        const pmt = session._pmt;
        const thresholds = session._thresholds;
        let intakes = null;
        if (pmt && pmt.numberPills >= 0) {
          intakes = pmt.numberPills * thresholds.mgPerPill;
        }
        /**
         * Thresholds can be undefined, so
         * need to account for that when creating
         * the thresholdSeries y data
         */
        let thresholdsY = null;
        if (thresholds) {
          thresholdsY =
            thresholds.pillsPerDose *
            thresholds.dosesPerDay *
            thresholds.mgPerPill;
        }
        data[0].push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: intakes,
          x: i
        });
        data[1].push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: thresholdsY,
          x: i
        });
        data[2].push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: pmt?.ratePain,
          x: i
        });
      }
      intakeSeries.data = data[0];
      thresholdSeries.data = data[1];
      painSeries.data = data[2];
      options.series = [intakeSeries, thresholdSeries, painSeries];
      options.xAxis = {
        ...currentOptions.xAxis
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxOpioidMgmt>
      url="/epxopioidmgmt/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxOpioidMgmtGraphs;
